<template>
    <div class="w-full">
        <date-picker
            class="w-full"
            v-if="type === 'date' || type === 'datetime' || type === 'time'"
            v-model="date"
            :model-config="modelConfig"
            :mode="mode"
            :name="name"
            :disabled="disabled"
            :placeholder="placeholder"
            :autocomplete="autocomplete"
            :required="required"
            :is-required="isRequired"
            :min-date="minDate"
            @update:modelValue="updateModel"
            is24hr
        >
            <template v-slot="{ inputValue, inputEvents, togglePopover }">
                <div class=" input fc-input w-full">
                    <input type="hidden" :name="name" :value="date">
                    <input
                        @focus="togglePopover()"
                        :value="inputValue"
                        v-on="inputEvents"
                        class="bg-transparent w-full p-0 appearance-none border-0 focus:outline-none"
                    />
                </div>
            </template>

        </date-picker>

        <input
            :maxlength="maxlength"
            v-else
            ref="input"
            class="input fc-input"
            :type="type"
            :name="name"
            :required="required"
            :disabled="disabled"
            :value="inputVal"
            :placeholder="placeholder"
            :autocomplete="autocomplete"
            :id="attributes && attributes.id ? attributes.id : null"
            @keyup="update"
            @change="update"
            @blur="$emit('blur', $event)"
        />
    </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";

export default {
    components: {
        DatePicker,
    },
    props: [
        'label',
        'name',
        'type',
        'value',
        'modelValue',
        'placeholder',
        'attributes',
        'disabled',
        'autocomplete',
        'required',
        'timezone',
        'minDate',
        'isRequired',
        'maxlength',
    ],
    data() {
        return {
            date: this.modelValue || this.value,
            modelConfig: {
                type: 'string',
                mask: this.format()
            },
        };
    },
    computed: {
        inputVal() {
            return this.modelValue || this.value || '';
        },
        mode() {
            if (this.type === 'datetime') {
                return 'dateTime';
            }

            return this.type;
        },
    },
    methods: {
        format() {
            if (this.type === 'datetime') {
                return 'YYYY-MM-DD HH:mm:ss';
            }
            if (this.type === 'time') {
                return 'HH:mm:ss';
            }
            return 'YYYY-MM-DD';
        },
        update($event) {
            this.$emit('update:modelValue', $event.target.value);
        },
        updateModel(value) {
            this.$emit('update:modelValue', value);
        }
    }
}
</script>
